// Module
var code = `<section class="deeplink-mobile">

    <div class="deeplink-mobile__hero">

        <img
            class="deeplink-mobile__hero-background"
            ng-src="{{ \$ctrl.data.mobile.heroBackground }}"
            alt=""
            aria-hidden="true">

        <img
            class="deeplink-mobile__hero-logo"
            ng-src="{{ \$ctrl.data.mobile.heroLogo }}"
            alt="Toke">

        <img
            class="deeplink-mobile__hero-coin"
            ng-src="{{ \$ctrl.data.mobile.heroCoin }}"
            alt=""
            aria-hidden="true">

        <div class="deeplink-mobile__badge">
            {{ \$ctrl.data.mobile.badgeLabel }}
        </div>

    </div>

    <div class="deeplink-mobile__card">

        <h1 class="deeplink-mobile__title">
            {{ \$ctrl.data.header.title }}
        </h1>

        <p class="deeplink-mobile__subtitle">
            {{ \$ctrl.data.header.subtitle }}
        </p>

        <div class="deeplink-mobile__buttons">

            <button
                class="deeplink-mobile__button"
                ng-repeat="channel in \$ctrl.data.channels track by channel.id"
                ng-click="\$ctrl.redirectToChannel(channel.id)">

            <img
                class="deeplink-mobile__button-logo {{ channel.logoClass }}"
                ng-src="{{ channel.logo }}"
                alt="{{ channel.label }}">

            </button>

        </div>

        <div class="deeplink-mobile__secure">

            <img
                class="deeplink-mobile__secure-icon"
                ng-src="{{ \$ctrl.data.mobile.secureIcon }}"
                alt=""
                aria-hidden="true">

            <span class="deeplink-mobile__secure-text">
                {{ \$ctrl.data.mobile.secureLabel }}
            </span>

        </div>

    </div>

</section>`;
// Exports
export default code;